<template>
	<div class="subject-audit-detail">
		<div class="container-fluid">
			<!-- Begin page -->
			<div class="wrapper">
				<div class="content-page content-subProject">
					<div class="content">
						<div class="row">
							<div class="col-12">
								<div class="page-title-box">
									<div class="page-title-right"><Breadcrumb /></div>
									<h3 class="header-title mb-3">专家评审打分</h3>
								</div>
								<!-- end page-title-box -->
							</div>
						</div>

						<div class="row">
							<div class="col-12">
								<div class="card">
									<div class="card-body">
										<div class="card-reviewDetails">
											<h3 class="text-center">{{ topicInfo.title }}</h3>
											<!-- 在线开题报告 -->
											<div class="view">
												<div class="view-div">
													<div v-for="(item, index) in topicInfo.list1" :key="index">
														<h3 class="view-tit" :class="tabIndex == index ? 'active' : ''" @click="preview(item, index)">{{ item.value }}</h3>
													</div>
												</div>
												<iframe
													v-if="isFileType"
													:src="urlFile"
													frameborder="0"
													style="height: 700px;width: 100%;border: 1px solid #eeeeee;text-align: center;"
												></iframe>
												<div v-else style="height: 700px;width: 100%;border: 1px solid #eeeeee;text-align: center;">
													<video
														ref="previewVideo"
														style="width: 100%;height: 700px;"
														autoplay
														controls
														v-if="curPreviewFileType == 'video'"
														:src="curPreviewFileUrl"
													></video>
												</div>
											</div>
											<div class="annex" v-if="topicInfo.eduAnnex">
												<div class="annex-item">
													<span class="item-name">评审标准附件：</span>
													<span class="item-text" @click="downFile">{{ topicInfo.eduAnnex.name }}</span>
												</div>
											</div>
											<el-table
												id="table"
												:header-cell-style="tableStyle"
												border
												:data="topicSumData"
												style="width: 100%;margin-bottom: 20px;margin-top: 20px;"
											>
												<el-table-column prop="name" label="评分标准" width="200"></el-table-column>
												<el-table-column prop="note" label="评分标准说明"></el-table-column>
												<el-table-column prop="score" label="分值" width="80"></el-table-column>
												<el-table-column prop="totalPoints" label="得分" width="200">
													<template v-slot:default="scope">
														<el-input v-if="scope.row.isShow" :disabled="isDis" v-model="scope.row.totalPoints" clearable></el-input>
													</template>
												</el-table-column>
											</el-table>
											<div>
												<h4>评语：</h4>
												<el-input type="textarea" :disabled="isDis" :rows="4" v-model="note"></el-input>
											</div>
											<div class="text-center" style="margin-top: 5vh;">
												<el-button type="primary" @click="submitBtn(0)" v-if="isShow">确定</el-button>
												<!-- <el-button type="primary" style="margin-left: 20px;" @click="submitBtn(1)">保存并下一个</el-button> -->
												<button type="button" class="btn btn-light" style="margin-left: 20px;" @click="goBack">返回</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- end wrapper-->
		</div>
	</div>
</template>

<script>
import { getApiReviewInfo, getEduScoringCriteria, saveExpertsScoreUp } from '@/api/after/newInterface.js';
import Breadcrumb from '@/views/backstage/components/Breadcrumb.vue';
export default {
	components: {
		Breadcrumb
	},
	data() {
		return {
			filePreviewDialogVisible: false,
			curPreviewFileDialogTitle: '',
			curPreviewFileType: '', //当前预览文件类型
			curPreviewFileUrl: '', //当前预览文件URL
			topicSumData: [],
			topicInfo: {}, //课题信息
			tableStyle: {
				backgroundColor: '#7e9be2',
				color: '#fff',
				textAlign: 'center'
			},
			titleArr: [],
			tabIndex: 0,
			note: '',
			ids: '',
			projectId: '',
			isShow: true,
			isDis: false,
			scoreNum: 0,
			isFileType: true,
			fileId: null,
			urlFile: '',
			states: ''
		};
	},
	filters: {
		getMember(val) {
			if (val) {
				return val.replace(/,/g, '、');
			}
		},
		formatFileType(val) {
			switch (val) {
				case 'pic':
					return '图片';
					break;
				case 'doc':
					return '文档';
					break;
				case 'docx':
					return '文档';
					break;
				case 'video':
					return '视频';
					break;
				case 'other':
					return '其他文件';
					break;
				default:
			}
		}
	},
	mounted() {
		this.ids = this.$route.query.id;
		this.states = this.$route.query.state;
		this.projectId = this.$route.query.projectId;
		this.getTable();
		this.getInfo();
	},
	methods: {
		goBack() {
			this.$router.push(`/backstage/reviewWorks?id=${this.projectId}&state=${this.states}`);
		},
		submitBtn(type) {
			let score = this.topicSumData.slice(-1)[0].totalPoints;
			if (!score) {
				this.$message.error('请填写总分');
				return;
			}
			if (type == 0) {
				if (score > this.scoreNum) {
					this.$message.error('得分不得超过评分标准中设置的总分');
					return;
				}
				this.submitScore(score);
			} else {
				if (this.topicInfo.longs == 0) {
					this.$message.error('已是最后一个作品');
					return;
				}
				this.submitScore(score);
				this.getTable();
				this.getInfo();
			}
		},
		submitScore(score) {
			let params = {
				projectManagementId: this.ids,
				settingId: this.projectId,
				score,
				note: this.note
			};
			saveExpertsScoreUp(params).then(res => {
				if (res.code == 200) {
					this.$message.success('操作成功');
					this.$router.push(`/backstage/reviewWorks?id=${this.projectId}&state=${this.states}`);
				} else {
					this.$message.error(res.data);
				}
			});
		},
		getTable() {
			let params = {
				pageNumber: 1,
				pageSize: 999,
				groupId: this.projectId,
				type: 1
			};

			getEduScoringCriteria(params).then(res => {
				if (res.code == 200) {
					this.topicSumData = res.data.records;
					if (this.topicSumData && this.topicSumData.length) {
						this.scoreNum = this.topicSumData.map(item => item.score).reduce((pre, item) => pre + item);
						let params = { name: '总分', score: this.scoreNum, isShow: true, totalPoints: '' };
						this.topicSumData.push(params);
					}
				} else {
					this.$message.error(res.msg);
				}
			});
		},
		// 关闭文件预览对话框
		closePreviewFileDialog() {
			this.filePreviewDialogVisible = false;
			if (this.curPreviewFileType === 'video') {
				this.$refs.previewVideo.pause();
			}
		},
		// 打开预览文件对话框
		preview(item, index = 0) {
			this.tabIndex = index;
			if (item.fileType == 'video') {
				this.curPreviewFileType = 'video';
				this.curPreviewFileUrl = `${this.uploadUrl}/upload/previewVideo/${item.id}`;
				this.isFileType = false;
			} else {
				this.isFileType = true;
				let file = `${this.uploadFile}${item.url}`;
				let xurl = 'https://view.xdocin.com/xdoc?_xdoc=';
				xurl += encodeURIComponent(file);
				let ops = {
					pdf: true,
					img: false,
					ppt: true,
					pptx: true,
					pic: true,
					fontsize: '18',
					xls: true,
					xlsx: true,
					zip: true,
					jpg: true,
					png: true
				};
				for (let a in ops) {
					xurl += '&' + a + '=' + encodeURIComponent(ops[a]);
				}
				if (item.url) {
					this.urlFile = xurl;
				} else {
					this.urlFile = '';
				}
			}
		},
		downFile() {
			this.downFileList(`${this.uploadUrl}/upload/download?id=${this.topicInfo.eduAnnex.id}&openStyle=1`, this.topicInfo.eduAnnex.name);
		},
		// 下载文件，自定义文件名称
		downFileList(url, fileName) {
			const x = new XMLHttpRequest();
			x.open('GET', url, true);
			x.responseType = 'blob';
			x.onload = function() {
				const url = window.URL.createObjectURL(x.response);
				const a = document.createElement('a');
				a.href = url;
				a.download = fileName;
				a.click();
			};
			x.send();
		},
		// 征文详情
		getInfo() {
			getApiReviewInfo(this.ids).then(res => {
				if (res.code == 200) {
					console.log('getInfo', res);
					this.topicInfo = res.data;
					if (this.topicInfo.eduProjectManagementExpertsScore) {
						this.note = this.topicInfo.eduProjectManagementExpertsScore.note;
						this.topicSumData.slice(-1)[0].totalPoints =
							this.topicInfo.eduProjectManagementExpertsScore.score == 0 ? ' ' : this.topicInfo.eduProjectManagementExpertsScore.score;
					}
					this.isDis = this.topicInfo.eduProjectManagementExpertsScore.isSubmit == 1 ? true : false;
					this.isShow = this.topicInfo.eduProjectManagementExpertsScore.isSubmit == 1 ? false : true;
					if (this.topicInfo.list) {
						let arr = this.topicInfo.list.filter(item => item.id);
						this.preview(arr[0]);
					}
				} else {
					this.$message.error(res.msg);
				}
			});
		},
		handleClose(done) {
			this.$confirm('确认关闭？')
				.then(_ => {
					done();
				})
				.catch(_ => {});
		}
	}
};
</script>

<style scoped lang="scss">
.view_report {
	margin-top: 50px;
}
.preview_wrap {
	height: 100%;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
}
.file_list {
	border-bottom: 1px solid #ccc;
	.file_list_title {
		font-size: 18px;
		font-weight: bolder;
		margin-bottom: 15px;
	}
	.file_item {
		display: flex;
		align-items: center;
		margin-bottom: 10px;
		cursor: pointer;
		.file_type {
			font-size: 18px;
			font-weight: bolder;
			margin-right: 20px;
		}
	}
	.file_item:hover {
		color: #006dcc;
	}
}
.view {
	width: 1000px;
}
.comments-list {
	margin-top: 20px;
}
.file-list {
	width: 100%;
	display: flex;
	justify-content: center;
	padding-left: 0;
	list-style: none;
	.file-item {
		font-size: 24px;
		text-align: center;
		width: 50%;
		border-bottom: 2px solid #eee;
		cursor: pointer;
	}
}
.file-item.active {
	border-color: #00a2e8;
}
.view-div {
	display: flex;
	justify-content: center;
	align-items: center;
}
.view-tit {
	font-weight: 700;
	width: 150px;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	-o-text-overflow: ellipsis;
	cursor: default;
	font-size: 1.2rem;
}
.active {
	color: #006dcc !important;
}

.annex {
	margin-top: 20px;
	.annex-item {
		.item-text {
			color: #409eff;
			cursor: pointer;
		}
	}
}
</style>
